module.exports = __webpack_public_path__ + "img/instagram.cbf84a77.svg";